import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import Document from "./components/Pages/Document/Document";
import DocumentRPD from "./components/Pages/Document/DocumentRPD";
import Code from "./components/Pages/Code/Code";
import Home from "./components/Home";
import Read from "./components/Pages/Read/Read";
import Error from "./components/Pages/Exceptions/Default/Error";
import MaxReadMessage from "./components/Pages/Exceptions/Default/MaxReadMessage";
import ExpireMessage from "./components/Pages/Exceptions/Default/ExpireMessage";
import LaunchMessage from "./components/Pages/Exceptions/Default/LaunchMessage";
import NoInternet from "./components/Pages/Exceptions/Default/NoInternet";
import NoLongerAvailable from "./components/Pages/Exceptions/Default/NoLongerAvailable";
import Printing from "./components/Pages/Exceptions/Default/Printing";
import Restricted from "./components/Pages/Exceptions/Default/Restricted";
import DocumentAccess from "./components/Pages/Exceptions/Default/DocumentAccess";
import ReaderAccess from "./components/Pages/Exceptions/Default/ReaderAccess";
import NoAccessMessage from "./components/Pages/Exceptions/Default/NoAccess";
import NoPlan from "./components/Pages/Exceptions/Default/NoPlan";
import MaxReadDocument from "./components/Pages/Exceptions/Default/MaxReadDocument";
import SecurityAlert from "./components/Pages/Exceptions/Default/SecurityAlert";
import BotMessage from "./components/Pages/Exceptions/Default/BotMessage";
import AccessDenied from "./components/Pages/Exceptions/Default/AccessDenied";

import XeroxError from "./components/Pages/Exceptions/Xerox/Error";
import XeroxMaxReadMessage from "./components/Pages/Exceptions/Xerox/MaxReadMessage";
import XeroxExpireMessage from "./components/Pages/Exceptions/Xerox/ExpireMessage";
import XeroxLaunchMessage from "./components/Pages/Exceptions/Xerox/LaunchMessage";
import XeroxNoInternet from "./components/Pages/Exceptions/Xerox/NoInternet";
import XeroxNoLongerAvailable from "./components/Pages/Exceptions/Xerox/NoLongerAvailable";
import XeroxPrinting from "./components/Pages/Exceptions/Xerox/Printing";
import XeroxRestricted from "./components/Pages/Exceptions/Xerox/Restricted";
import XeroxDocumentAccess from "./components/Pages/Exceptions/Xerox/DocumentAccess";
import XeroxReaderAccess from "./components/Pages/Exceptions/Xerox/ReaderAccess";
import XeroxNoAccessMessage from "./components/Pages/Exceptions/Xerox/NoAccess";
import XeroxSessionExpire from "./components/Pages/Exceptions/Xerox/SessionExpireMessage";
import SessionExpire from "./components/Pages/Exceptions/Default/SessionExpireMessage";
import NoDocument from "./components/Pages/Exceptions/Default/NoDocument";
import XeroxNoDocument from "./components/Pages/Exceptions/Xerox/NoDocument";
import XeroxNoPlan from "./components/Pages/Exceptions/Xerox/NoPlan";
import XeroxNoMaxReadDocument from "./components/Pages/Exceptions/Xerox/MaxReadDocument";
import XeroxBotMessage from "./components/Pages/Exceptions/Xerox/BotMessage";

import RpdUpload from "./components/Pages/IOS/RpdUpload";

import "./App.css";
import langTranslationsWrapper from "./hocs/langTranslationsWrapper";

const CodeWrapper = langTranslationsWrapper(Code);
const DocumentWrapper = langTranslationsWrapper(Document);
const DocumentRPDWrapper = langTranslationsWrapper(DocumentRPD);
const ExpireMessageWrapper = langTranslationsWrapper(ExpireMessage);
const MaxReadMessageWrapper = langTranslationsWrapper(MaxReadMessage);
const NoAccessMessageWrapper = langTranslationsWrapper(NoAccessMessage);
const NoLongerAvailableWrapper = langTranslationsWrapper(NoLongerAvailable);
const RestrictedWrapper = langTranslationsWrapper(Restricted);
const DocumentAccessWrapper = langTranslationsWrapper(DocumentAccess);
const BotMessageWrapper = langTranslationsWrapper(BotMessage);
const ReaderAccessWrapper = langTranslationsWrapper(ReaderAccess);
const NoInternetWrapper = langTranslationsWrapper(NoInternet);
const LaunchMessageWrapper = langTranslationsWrapper(LaunchMessage);
const SessionExpireWrapper = langTranslationsWrapper(SessionExpire);
const NoDocumentWrapper = langTranslationsWrapper(NoDocument);
const NoPlanWrapper = langTranslationsWrapper(NoPlan);
const MaxReadDocumentWrapper = langTranslationsWrapper(MaxReadDocument);
const SecurityAlertWrapper = langTranslationsWrapper(SecurityAlert);
const AccessDeniedWrapper = langTranslationsWrapper(AccessDenied);

const RpdUploadWrapper = langTranslationsWrapper(RpdUpload);




//Xerox
const XeroxErrorWrapper = langTranslationsWrapper(XeroxError);
const XeroxMaxReadMessageWrapper = langTranslationsWrapper(XeroxMaxReadMessage);
const XeroxNoAccessMessageWrapper = langTranslationsWrapper(XeroxNoAccessMessage);
const XeroxExpireMessageWrapper = langTranslationsWrapper(XeroxExpireMessage);
const XeroxLaunchMessageWrapper = langTranslationsWrapper(XeroxLaunchMessage);
const XeroxNoInternetWrapper = langTranslationsWrapper(XeroxNoInternet);
const XeroxNoLongerAvailableWrapper = langTranslationsWrapper(XeroxNoLongerAvailable);
const XeroxPrintingWrapper = langTranslationsWrapper(XeroxPrinting);
const XeroxRestrictedWrapper = langTranslationsWrapper(XeroxRestricted);
const XeroxDocumentAccessWrapper = langTranslationsWrapper(XeroxDocumentAccess);
const XeroxReaderAccessWrapper = langTranslationsWrapper(XeroxReaderAccess);
const XeroxBotMessageWrapper = langTranslationsWrapper(XeroxBotMessage);
const XeroxSessionExpireWrapper = langTranslationsWrapper(XeroxSessionExpire);
const XeroxNoDocumentWrapper = langTranslationsWrapper(XeroxNoDocument);
const XeroxNoPlanWrapper = langTranslationsWrapper(XeroxNoPlan);
const XeroxNoMaxReadDocumentWrapper = langTranslationsWrapper(XeroxNoMaxReadDocument);




function App() {
  
  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route
            path="/read/:documentId/:openId/:docType"
            element={<DocumentWrapper />}
          />
          <Route path="/read/:documentId/:openId" element={<DocumentRPDWrapper />} />
          <Route path="/read/:documentId" element={<DocumentWrapper />} />
          <Route path="/code/:documentId/:typeId" element={<CodeWrapper />} />
          <Route
            path="/code/:documentId/:typeId/:fileName"
            element={<CodeWrapper />}
          />
          <Route
            path="/code/:documentId/:typeId/:level/:fileName"
            element={<CodeWrapper />}
          />
          <Route path="/read" element={<Read />} />
          <Route path="/home" element={<Home />} />
          <Route
            path="/rpdupload/:documentId/:typeId"
            element={<RpdUploadWrapper />}
          />

          <Route path="/Default/Error" element={<Error />} />
          <Route
            path="/Default/MaxReadMessage/:documentId/:fileName"
            element={<MaxReadMessageWrapper />}
          />
          <Route
            path="/Default/NoAccess/:documentId/:fileName"
            element={<NoAccessMessageWrapper />}
          />
          <Route
            path="/Default/ExpireMessage/:documentId/:fileName"
            element={<ExpireMessageWrapper />}
          />
          <Route
            path="/Default/LaunchMessage/:documentId/:fileName/:launchDate/:launchTime"
            element={<LaunchMessageWrapper />}
          />
          <Route
            path="/Default/LaunchMessage/:documentId/:fileName/:launchDate"
            element={<LaunchMessageWrapper />}
          />
          <Route
            path="/Default/NoInternet/:documentId"
            element={<NoInternetWrapper />}
          />
          <Route
            path="/Default/NoLongerAvailable/:documentId"
            element={<NoLongerAvailableWrapper />}
          />
          <Route path="/Default/Printing/:documentId" element={<Printing />} />
          <Route
            path="/Default/Restricted/:documentId"
            element={<RestrictedWrapper />}
          />
          <Route
            path="/Default/DocumentAccess/:documentId"
            element={<DocumentAccessWrapper />}
          />
          <Route
            path="/Default/BotMessage/:documentId"
            element={<BotMessageWrapper />}
          />
          <Route
            path="/Default/BotMessage/:documentId/:fileName"
            element={<BotMessageWrapper />}
          />
          <Route
            path="/Default/Restricted/:documentId/:fileName"
            element={<RestrictedWrapper />}
          />
          <Route
            path="/Default/DocumentAccess/:documentId/:fileName"
            element={<DocumentAccessWrapper />}
          />
          <Route
            path="/Default/ReaderAccess/:documentId/:fileName"
            element={<ReaderAccessWrapper />}
          />
          <Route
            path="/Default/SessionExpireMessage/:documentId/:level/:fileName"
            element={<SessionExpireWrapper />}
          />
          <Route
            path="/Default/NoDocument/:documentId/:fileName"
            element={<NoDocumentWrapper />}
          />
          <Route
            path="/Default/NoPlan/:documentId/:fileName"
            element={<NoPlanWrapper />}
          />
          <Route
            path="/Default/MaxReadDocument/:documentId/:fileName"
            element={<MaxReadDocumentWrapper />}
          />
          <Route
            path="/Default/SecurityAlert/:documentId/:fileName"
            element={<SecurityAlertWrapper />}
          />
          <Route
            path="/Default/AccessDenied/:documentId/:fileName"
            element={<AccessDeniedWrapper />}
          />

          <Route path="/Xerox/Error/:documentId" element={<XeroxErrorWrapper />} />
          <Route
            path="/Xerox/MaxReadMessage/:documentId/:fileName"
            element={<XeroxMaxReadMessageWrapper />}
          />
          <Route
            path="/Xerox/NoAccess/:documentId/:fileName"
            element={<XeroxNoAccessMessageWrapper />}
          />
          <Route
            path="/Xerox/ExpireMessage/:documentId/:fileName"
            element={<XeroxExpireMessageWrapper />}
          />
          <Route
            path="/Xerox/LaunchMessage/:documentId/:fileName/:launchDate/:launchTime"
            element={<XeroxLaunchMessageWrapper />}
          />
          <Route
            path="/Xerox/LaunchMessage/:documentId/:fileName/:launchDate"
            element={<XeroxLaunchMessageWrapper />}
          />
          <Route
            path="/Xerox/NoInternet/:documentId"
            element={<XeroxNoInternetWrapper />}
          />
          <Route
            path="/Xerox/NoLongerAvailable/:documentId"
            element={<XeroxNoLongerAvailableWrapper />}
          />
          <Route
            path="/Xerox/Printing/:documentId"
            element={<XeroxPrintingWrapper />}
          />
          <Route
            path="/Xerox/Restricted/:documentId"
            element={<XeroxRestrictedWrapper />}
          />
          <Route
            path="/Xerox/DocumentAccess/:documentId"
            element={<XeroxDocumentAccessWrapper />}
          />
          <Route
            path="/Xerox/BotMessage/:documentId"
            element={<XeroxBotMessageWrapper />}
          />

          <Route
            path="/Xerox/ReaderAccess/:documentId/:fileName"
            element={<XeroxReaderAccessWrapper />}
          />

          <Route
            path="/Xerox/Restricted/:documentId/:fileName"
            element={<XeroxRestrictedWrapper />}
          />
          <Route
            path="/Xerox/DocumentAccess/:documentId/:fileName"
            element={<XeroxDocumentAccessWrapper />}
          />
          <Route
            path="/Xerox/BotMessage/:documentId/:fileName"
            element={<XeroxBotMessageWrapper />}
          />
          <Route
            path="/Xerox/SessionExpireMessage/:documentId/:level/:fileName"
            element={<XeroxSessionExpireWrapper />}
          />
          <Route
            path="/Xerox/NoDocument/:documentId/:fileName"
            element={<XeroxNoDocumentWrapper />}
          />
          <Route
            path="/Xerox/NoPlan/:documentId/:fileName"
            element={<XeroxNoPlanWrapper />}
          />
          <Route
            path="/Xerox/MaxReadDocument/:documentId/:fileName"
            element={<XeroxNoMaxReadDocumentWrapper />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
